// OneDrive response property values
export const SharingLinkTypeView: string = 'view';
export const SharingLinkTypeEdit: string = 'edit';
export const SharingLinkScopeAnonymous: string = 'anonymous';
export const SharingLinkScopeOrganization: string = 'organization';
export const SharingLinkScopeUser: string = 'user';
